import { createRoute, useLoaderData } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";
import { unwrapPageInitialData, type PageInitialData } from "~/app/api/pageData";
import { notificationsPageQueryOptions } from "~/app/api/pageData/notificationsPageQuery";
import { StorefrontShellFrame } from "~/app/shell/StorefrontShellFrame";
import { useStorefrontShellProps } from "~/app/router/storefrontShellPropsContext";
import { rootRoute } from "~/app/router/rootRoute";
import { NotificationsPage } from "~/features/notifications/NotificationsPage/NotificationsPage";

function NotificationsRoute() {
  const result = useLoaderData({
    from: "/notifications",
  }) as PageInitialData<void>;
  const shellProps = useStorefrontShellProps();

  return (
    <StorefrontShellFrame variant={shellProps.variant} metadata={result.metadata}>
      <NotificationsPage />
    </StorefrontShellFrame>
  );
}

export async function loadNotificationsPageData(context: { queryClient: QueryClient }) {
  const result = await context.queryClient.ensureQueryData(notificationsPageQueryOptions());

  return unwrapPageInitialData(result);
}

export const notificationsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/notifications",
  loader: async ({ context }) => loadNotificationsPageData(context),
  component: NotificationsRoute,
});
